export interface Errors {
    error: string;
    [errorKey: string]: string;
}

export enum ErrorType {
    LOADING_APP_DATA = 'LOADING_APP_DATA',
}
